<template>
  <b-navbar toggleable="lg" type="dark" fixed="top" id="header">

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-navbar-brand class="mr-auto" :to="homePage">
      <img src="/static/img/songback-logo.svg" class="logo desktop-only">
    </b-navbar-brand>

    <ul class="extra-nav align-items-center">
      <b-nav-item :to="messagesLink" style="list-style: none">
        <font-awesome-icon icon="envelope"/>
        <div class="counter" v-if="artistMode && artistInbox && artistInbox.unread_count">{{ artistInbox.unread_count }}</div>
        <div class="counter" v-if="!artistMode && fanInbox && fanInbox.unread_count">{{ fanInbox.unread_count }}</div>
      </b-nav-item>
      <b-nav-item-dropdown right no-caret class="sb-dropdown">
        <template slot="text">
          <font-awesome-icon icon="bell"/>
          <div class="counter" v-if="relevantNotifications.length > 0">{{ relevantNotifications.length }}</div>
        </template>
        <div class="scrollable">
          <Notification v-for="(n, index) in relevantNotifications" :key="index" :notification="n" :artistMode="artistMode"/>
        </div>
        <b-dropdown-item v-if="relevantNotifications.length" class="text-center">
          <LinkButton :u="true" @click="markAsRead">mark all as read</LinkButton>
        </b-dropdown-item>
        <b-dropdown-item v-else>No new notifications</b-dropdown-item>
      </b-nav-item-dropdown>
    </ul>
      <b-nav class="mobile-only">
        <b-nav-item-dropdown right no-caret class="sb-dropdown">
          <template slot="text">
            <img class="avatar" :src="artist.avatar_image" v-if="artistMode && isArtist">
            <img class="avatar" :src="avatarImage" v-else>
          </template>
          <b-dropdown-item :to="{name: 'fan-profile-preview'}">Fan Account</b-dropdown-item>
          <b-dropdown-item v-if="isArtist" :to="{name: 'artist-dashboard', params: {id: currentUser.id}}">Artist Studio</b-dropdown-item>
          <b-dropdown-item v-else :to="{name: 'artist-onboarding'}">Artist Studio</b-dropdown-item>
          <b-dropdown-item @click="logout">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-nav>

    <b-collapse is-nav id="nav-collapse" ref="navCollapse">

      <b-navbar-nav class="flex-grow-1 justify-content-center">
        <SearchBox class="searchbox-nav" @search="collapseMenu"/>
      </b-navbar-nav>

      <NavLinks :withProfileLinks="true" :artist="artistMode && isArtist" class="mobile-only" @logout="logout"></NavLinks>

      <b-navbar-nav class="desktop-only-flex">
        <b-nav-item :to="messagesLink">
          <font-awesome-icon icon="envelope"/>
          <div class="counter" v-if="artistMode && artistInbox && artistInbox.unread_count">{{ artistInbox.unread_count }}</div>
          <div class="counter" v-if="!artistMode && fanInbox && fanInbox.unread_count">{{ fanInbox.unread_count }}</div>
        </b-nav-item>

        <b-nav-item-dropdown right no-caret class="sb-dropdown">
          <template slot="text">
            <font-awesome-icon icon="bell"/>
            <div class="counter" v-if="relevantNotifications.length > 0">{{ relevantNotifications.length }}</div>
          </template>
          <div class="scrollable">
            <Notification v-for="(n, index) in relevantNotifications" :key="index" :notification="n" :artistMode="artistMode"/>
          </div>
          <b-dropdown-item v-if="relevantNotifications.length" class="text-center">
            <LinkButton :u="true" @click="markAsRead">mark all as read</LinkButton>
          </b-dropdown-item>
          <b-dropdown-item v-else>No new notifications</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown right class="sb-dropdown">
          <template slot="text">
            <img class="avatar" :src="artist.avatar_image" v-if="artistMode && isArtist">
            <img class="avatar" :src="avatarImage" v-else>
            <span class="name">{{ dropdownName }}</span>
          </template>
          <b-dropdown-item :to="{name: 'fan-profile-preview'}">Fan Account</b-dropdown-item>
          <b-dropdown-item v-if="isArtist" :to="{name: 'artist-dashboard', params: {id: currentUser.id}}">Artist Studio</b-dropdown-item>
          <b-dropdown-item v-else :to="{name: 'artist-onboarding'}">Artist Studio</b-dropdown-item>
          <b-dropdown-item @click="logout">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  #header {
    .desktop-only, .desktop-only-flex {
      display: none;
    }
    .logo {
      &.mobile-only {
        display: none;
      }
    }
    .extra-nav {
      display: none;
      .nav-link {
        padding: 6px 0px;
        padding-right: 0px;
      }
      @include media-breakpoint-down(md) {
        display: flex;
        list-style: none;
        margin: 0;
      }
    }
  }

  @include media-breakpoint-up(lg) {
    #header {
      box-shadow: none;

      .desktop-only {
        display: block;
      }

      .desktop-only-flex {
        display: flex;
      }

      .mobile-only {
        display: none;
      }
    }
  }

  .message {
    display: flex;

    img {
      width: 24px;
      height: 24px;
      border-radius: 100%;
      margin-right: 5px;
    }

    .info {
      display: flex;

      .who {
        flex-grow: 1
      }

      .when {
        color: $steel;
        text-align: right;
      }
    }
  }

  #nav-collapse {
    align-items: center;

    .navbar-nav {
      align-items: center;
    }
  }

  .searchbox-nav {
    padding-top: 1em;

    @include media-breakpoint-up(lg) {
      max-width: 20em;
      padding-top: 0;
    }
  }

  .counter {
    width: 14px;
    height: 14px;
    font-size: 8px;
    border-radius: 12px;
    background-color: $darkish-pink;
    display: inline-block;
    padding-top: 2px;
    margin-left: -0.5em;
    text-align: center;
    vertical-align: top;
  }

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 100%;
  }

  .name {
    font-size: 0.8em;
  }

   /deep/ .sb-dropdown {

    .dropdown-menu.show {
      background-color: $dark;
      font-size: 0.8em;
      box-shadow: 7px 2px 9px 0 rgba(0, 0, 0, 0.6);
    }

    .dropdown-item {
      background: transparent;
      color: $steel;

      &:focus {
        outline: none;
      }

      &:hover {
        color: $white;
      }
    }
  }

  .mobile-only /deep/ .sb-dropdown .nav-link {
    padding: 0;
  }

  .scrollable{
    max-height: 60vh;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 5px;
      background-color: #49495b;
    }
    &::-webkit-scrollbar-track {
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: $steel;
      border: 1px solid #49495b;
    }
  }
</style>

<script>
import { mapGetters } from 'vuex'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import SearchBox from './SearchBox'
import NavLinks from './NavLinks'
import Notification from './Notification'
import LinkButton from './LinkButton'

export default {
  name: 'PrivateHeader',
  components: {
    FontAwesomeIcon,
    SearchBox,
    NavLinks,
    Notification,
    LinkButton
  },
  props: ['artistMode'],
  computed: {
    messagesLink () {
      return {name: (this.artistMode && this.isArtist) ? 'artist-messages' : 'fan-messages'}
    },
    relevantNotifications () {
      return this.artistMode ? this.artistNotifications : this.fanNotifications
    },
    dropdownName () {
      return (this.artistMode && this.isArtist) ? this.artist.name : this.displayName
    },
    homePage () {
      if (this.isArtist && this.artistMode) {
        return {name: 'artist-dashboard'}
      } else {
        return {name: 'fan-home'}
      }
    },
    ...mapGetters('profile', ['currentUser', 'avatarImage', 'displayName', 'isArtist', 'fanInbox', 'artistInbox']),
    ...mapGetters('realtime', ['artistNotifications', 'fanNotifications']),
    ...mapGetters('artist', ['artist'])
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout')
    },
    markAsRead () {
      this.$store.dispatch('realtime/readNotifications', { artistMode: this.artistMode })
    },
    collapseMenu () {
      if (document.getElementById('nav-collapse').className.match(/show/)) {
        this.$root.$emit('bv::toggle::collapse', 'nav-collapse')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/PrivateHeader.vue